import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { apiImportRequestTimeoutMs } from "../config";
import apiConfig from "../utils/apiConfig";

export default function useLeadImport(componentName = "useLeadImport") {
  const { post } = useApiHelper({
    ...apiConfig(componentName),
    timeoutMs: apiImportRequestTimeoutMs,
  });
  const queryClient = useQueryClient();

  const exportLeads = useMutation((leadIds) => post("/lead/exported", leadIds), {
    onSuccess: () => {
      queryClient.invalidateQueries(["leads"]);
    }
  });

  const importLeads = useMutation((leads) => post("/lead/import", leads), {
    onSuccess: () => {
      queryClient.invalidateQueries(["leads"]);
      queryClient.invalidateQueries(["pagedTable", "/lead/partialwithfilters"]);
    }
  });

  return {
    exportLeads,
    importLeads
  };
}
